<template>
  <van-popup
    v-model="show"
    position="bottom"
    round
    safe-area-inset-bottom
    @click-overlay="close"
  >
    <div class="header">
      <div class="title">赠品</div>
      <img
        class="close-icon"
        src="https://editor.xesimg.com/tailor/resource/close-1753957787448.png"
        @click="close"
      />
    </div>
    <div class="gift-popup-content">
      <div
        :class="[
          'gift-item',
          item.gift_product_type === 105 && 'goods-item',
          item.gift_product_type === 100 && 'course-item',
          item.gift_product_type === 201 && 'coupon-item',
        ]"
        v-for="item in gift_list"
        :key="item.type"
      >
        <div class="gift-item-type">{{ item.type }}</div>
        <div class="gift-item-content">
          <div
            class="gift-item-content-item"
            v-for="gift in item.gift_infos"
            :key="gift.id"
          >
            <div class="gift-name">{{ gift.name }}</div>
            <div>x{{ gift.quantity }}</div>
          </div>
        </div>
      </div>
    </div>
  </van-popup>
</template>
<script>
export default {
  props: {
    giftInfo: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    gift_list() {
      const typeConfigs = [
        { type: "实物", gift_product_type: 105 },
        { type: "优惠券", gift_product_type: 201 },
        { type: "课程", gift_product_type: 100 },
      ];

      return typeConfigs.reduce((result, config) => {
        const filtered = (this.giftInfo || []).filter(
          (item) => item.type === config.gift_product_type
        );
        if (filtered.length) {
          result.push({ ...config, gift_infos: filtered });
        }
        return result;
      }, []);
    },
  },
  methods: {
    open() {
      this.show = true;
    },
    close(e) {
      console.log(e);
      this.show = false;
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../assets/less/layout.less";
.header {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 52px;
  position: relative;
  .title {
    color: #333;
    text-align: center;
    font-family: "PingFang SC";
    font-size: 17px;
    font-weight: 500;
  }
  .close-icon {
    position: absolute;
    right: 18px;
    width: 16px;
    height: 16px;
  }
}
.gift-popup-content {
  padding: 12px 16px 24px 16px;
  max-height: 70vh;
  overflow: auto;
}
.gift-item {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 16px 12px;
  margin-bottom: 8px;
  border-radius: 12px;
  background: #f7f7f8;

  &:last-child {
    margin-bottom: 0;
  }

  .gift-item-type {
    display: flex;
    align-items: center;
    font-family: "PingFang SC";
    margin-right: 8px;
    margin-top: 2px;
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    height: 16px;
    padding: 0 3px;
    border-radius: 3px;
  }
}
.goods-item {
  .gift-item-type {
    border: 1px solid #4096ff;
    color: #4096ff;
  }
}
.course-item {
  .gift-item-type {
    border: 1px solid #e4a970;
    color: #c07d3c;
  }
}
.coupon-item {
  .gift-item-type {
    border: 1px solid #f93834;
    color: #f93834;
  }
}
.gift-item-content {
  flex: 1;
}
.gift-item-content-item {
  display: flex;
  margin-bottom: 8px;
  justify-content: space-between;
  color: #333;
  font-family: "PingFang SC";
  font-size: 13px;
  font-weight: 400;

  &:last-child {
    margin-bottom: 0;
  }
}

.gift-name {
  .ellipsis-two;
  margin-right: 24px;
}
</style>
